import { compose } from 'recompose';
import { withChartLayout, withChartLogic } from 'components/common';
import SkinAssessment from 'components/features/chart/system-assessment/skin-assessment/SkinAssessment';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';

const enhancers = [withChartLayout('Skin Assessment'), withSavedPatientChartsPage, withChartLogic];

const SkinAssessmentPage = compose(...enhancers)(SkinAssessment);
export default SkinAssessmentPage;
